define('taoQtiItem/qtiItem/core/interactions/SelectPointInteraction',['taoQtiItem/qtiItem/core/interactions/GraphicInteraction'], function(GraphicInteraction){
    var SelectPointInteraction = GraphicInteraction.extend({
        qtiClass : 'selectPointInteraction'
    });
    return SelectPointInteraction;
});


